module.exports = __webpack_public_path__ + "img/ciudad-slider.3ba48cf4.png";